module.exports = __webpack_public_path__ + "images/emoji/put_litter_in_its_place.2db08cf8c5d13d2b8dde.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/put_litter_in_its_place.png
// module id = yRsP
// module chunks = 24